import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import TaskExecLogsBlock from '../TaskExecLogsBlock';
import TasksExecsFormsBlockAsOwner from '../../../TasksExecsForms/TasksExecsFormsBlockAsOwner';
import Header from './Header';
import TaskStatBlock from '../TaskStatBlock';
import TaskParamsBlock from '../../../_common/TaskParamsBlock';

const taskDescTabName = 'taskDescTab';
const execLogTabName = 'execLogTab';
const taskParamsTabName = 'taskParamsTab';
const taskTabName = 'taskTabName';

// eslint-disable-next-line react/prefer-stateless-function
class TaskExecTaskOwnerItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActive: execLogTabName
    };
  }

  handleChangeTab = (e, tabName) => {
    e.preventDefault();
    this.setState({ tabActive: tabName });
  };

  render() {
    let execStatusIconClass = null;
    switch (this.props.exec.status) {
      case 1: {
        execStatusIconClass = 'text-success fa fa-play-circle';
        break;
      }
      case 2: {
        execStatusIconClass = 'text-info fa fa-file-text';
        break;
      }
      case 3: {
        execStatusIconClass = 'text-danger fa fa-undo';
        break;
      }
      case 4: {
        execStatusIconClass = 'text-success fa fa-check-circle';
        break;
      }
      case 5: {
        execStatusIconClass = 'text-danger fa fa-times-circle';
        break;
      }
      case 6: {
        execStatusIconClass = 'text-danger fa fa-times-circle';
        break;
      }
      case 7: {
        execStatusIconClass = 'text-warning fa fa-gavel';
        break;
      }
      default:
        break;
    }

    let body;
    if (this.state.tabActive === execLogTabName) {
      body = (
        <TaskExecLogsBlock
          execId={this.props.exec.id}
          lastExecLog={this.props.exec.lastExecLog}
          userRepeatsAmount={this.props.exec.sequence_number_by_user}
        />
      );
    } else if (this.state.tabActive === taskParamsTabName) {
      body = <TaskParamsBlock task={this.props.exec.task} />;
    } else if (this.state.tabActive === taskTabName) {
      body = (
        <TaskStatBlock
          taskId={this.props.exec.task.id}
          tasksExecsStat={this.props.exec.task.tasksExecsStat}
        />
      );
    } else if (this.state.tabActive === taskDescTabName) {
      body = (
        <div className="pre-formatted">
          <div>
            Ссылка:{' '}
            <a
              href={this.props.exec.taskLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {this.props.exec.taskLink}
            </a>
          </div>
          {this.props.exec.task.desc}
        </div>
      );
    }
    return (
      <article className="panel panel-default task task_detailed">
        <Header {...this.props} />
        <div className="panel-bar">
          <div className="hor-scroll hor-scroll_xs hor-scroll_sub">
            <ul className="nav nav-tabs hor-scroll-wrapper">
              <li>
                <a
                  data-toggle="tab"
                  href=""
                  onClick={e => this.handleChangeTab(e, taskDescTabName)}
                >
                  {t('Описание задачи')}
                </a>
              </li>
              <li className="active">
                <a
                  data-toggle="tab"
                  href=""
                  onClick={e => this.handleChangeTab(e, execLogTabName)}
                >
                  <i
                    data-toggle="tooltip"
                    className={execStatusIconClass}
                    title={this.props.exec.statusName}
                  />{' '}
                  {t('Выполнение {id}', { id: `ID-${this.props.exec.id}` })}
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href=""
                  onClick={e => this.handleChangeTab(e, taskParamsTabName)}
                >
                  {t('Параметры')}
                </a>
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href=""
                  onClick={e => this.handleChangeTab(e, taskTabName)}
                >
                  {t('Статистика')}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="panel-body border-simple-b">{body}</div>
        <TasksExecsFormsBlockAsOwner {...this.props} />
      </article>
    );
  }
}

TaskExecTaskOwnerItem.propTypes = {
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ownerId: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    statusName: PropTypes.string.isRequired,
    ownerName: PropTypes.string,
    ownerAvatarPath: PropTypes.string,
    lastExecLog: PropTypes.shape({}),
    taskLink: PropTypes.string.isRequired,
    sequence_number_by_user: PropTypes.number,
    task: PropTypes.shape({
      id: PropTypes.number.isRequired,
      tasksExecsStat: PropTypes.shape({}).isRequired,
      desc: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};

export default withRouter(TaskExecTaskOwnerItem);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecTaskOwnerItem/TaskExecTaskOwnerItem.js